import React, {useState, useEffect, useContext} from "react";
import { getAttendanceStats } from './service'
import useApi from "../../hooks/useApi";
import Table from "../../uicomponents/table/Table";
import moment from "moment";
import { TeamManagementContext } from "./teammanagementContext"
import styles from "../../assets/stylesheets/pages/teammanagement/teamlead.module.scss"
import capitalise from "../../helper/Capitalise";

const AttendanceStats = () => {
    const { setAgentListView, teamSelected, setTeamSelected } = useContext(TeamManagementContext)
    const getAttendanceStatsApi = useApi(getAttendanceStats)

    useEffect(() => {
        const {agent} = teamSelected || {}
        const payload = {
            "userId": agent.id,
            "startDate": moment().subtract(6, 'day').format("YYYY-MM-DD"),
            "endDate":  moment().format("YYYY-MM-DD"),
        }
        getAttendanceStatsApi.request(payload)
    }, [])

    const styleStatusAttendance = (attendance = 'absent') => {
        return attendance.toLowerCase() == 'absent' ? `${styles.caller_status_styling} ${styles.idle}`
        : `${styles.caller_status_styling} ${styles.active}`
    }
    const formatAttendanceStatus = (attendance = 'absent') => {
        switch (attendance) {
            case 'present':
                return 'Present'
            default:
                return capitalise(attendance)
        }
    }

    const getTimeFormat = (value) => {
        let totalSeconds = value
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        // If you want strings with leading zeroes:
        minutes = String(minutes).padStart(2, "0");
        hours = String(hours).padStart(2, "0");
        seconds = String(seconds).padStart(2, "0");

        // return moment(seconds*1000).format('HH:mm:ss')
        return `${hours}h ${minutes}m  ${seconds}s`
    }

    const columns = [
        {
            Header: 'Date',
            accessor: 'createdAt',
            width: '10%',
            Cell: ({value}) => {
                return <span>{moment(value).format('DD-MM-YYYY')}</span>
            },
            // disableSortBy: true

        },
        {
            Header: 'Attendance',
            accessor: 'attendance',
            Cell: ({value}) => (<div className={styleStatusAttendance(value)}>{formatAttendanceStatus(value)}</div>),
            disableSortBy: true
        },
        {
            Header: 'Reason',
            accessor: 'reason',
            Cell: ({value}) => <span>--</span>,
            disableSortBy: true
        },
        {
            Header: 'Working Time',
            accessor: 'productiveTime',
            Cell: ({value}) => ( value ? getTimeFormat(value) : 0),
        },
        {
            Header: 'Calls Attempted',
            accessor: 'calls_attempted',
            Cell: ({cell}) => (<div>{Number(cell.row.original.connectedAttempts)+
            Number(cell.row.original.notConnectedAttempts)}</div>),
        },
        {
            Header: 'Calls Connected',
            accessor: 'connectedAttempts'
        },
        {
            Header: 'Mins Spoken',
            accessor: 'spokenMin'
        },
        // {
        //     Header: 'Action',
        //     // accessor: (row) => capitalise(row.status),
        //     width: '10%',
        //     disableSortBy: true
        // },
    ]
    const {data, loading, error} = getAttendanceStatsApi || {}
    const {data: stats} = data || {}

    return(
        <div>
            <div><b>Duration : </b> {moment().subtract(6, 'day').format("DD-MM-YYYY")} to {moment().format("DD-MM-YYYY")}</div>
            {error && <p>{typeof error == 'object' && 
            error !== null &&
            !Array.isArray(error)
            ? error.error || error.msg : error}</p>}
            <Table
            columns={columns}
            data={stats && stats.length > 0 ? stats : []}
            totalCount={stats && stats.length ? stats.length : 0}
            limit={7}
            currentPage={1}
            loading={loading}
            type = 'client'
            isGlobalFilter={false}
            manualSortBy={false}
            // searchBy="project id / title / status"
            />
        </div>
    )
}

export default AttendanceStats